import axios from "axios";
import { url } from "./server";

const api = axios.create({
    baseURL: `${url}/api`
});
api.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('TOKEN_AUTH')}`
// api.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
export default api;